/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-11-16",
    versionChannel: "nightly",
    buildDate: "2023-11-16T00:14:37.965Z",
    commitHash: "ffdb248872c89b586a83aaefc5cca3c98b8e5e8c",
};
